import { chain, each, get } from 'lodash'
import useDateFormat from '@/views/composable/useDateFormat'
import useValidation from '@/views/composable/useValidation'
import { ReceiptHeaders } from '@/utils/constants/table-headers'

export default receipts => {
  const { isValidDateTimeAttributes } = useValidation()
  const { dateTime } = useDateFormat()

  const buildXlsxData = () => {
    return chain(receipts.value)
      .map(o => {
        const data = {}
        each(ReceiptHeaders, h => {
          if (h.value === 'attributes.pamentMethodNames') {
            data[h.text] = o.attributes.pamentMethodNames.join(', ')

            return
          }
          if (isValidDateTimeAttributes(h.value)) {
            const dateTimeValue = get(o, h.value)

            data[h.text] = dateTimeValue ? dateTime(dateTimeValue) : null

            return
          }
          data[h.text] = get(o, h.value)
        })

        return data
      })
      .value()
  }

  return {
    buildXlsxData,
  }
}
